import { data } from '../../svg/Filter/data';
import { makeIcon } from '../makeIcon';

export const Filter = makeIcon(data, 'filter', 'Filter');

export default Filter;
